module.exports = __webpack_public_path__ + "static/saijo-400-c306e83348115a0bec8a4d9e79060e54.jpg";